import {
  cellRenderClosedStatus,
  cellRenderParseData,
  cellRenderStatusAct
} from '../../utils/functions';

const zdvlColumnDataGrid = [
  {
    dataField: 'lineId',
    caption: 'Номер позиции в SAP ERP',
    cellRender: cellRenderClosedStatus,
    dataType: 'string'
  },
  {
    dataField: 'orderId',
    caption: 'Номер заказа на переработку',
    dataType: 'string',
    cellRender: cellRenderClosedStatus,
    // cssClass: 'td-button-cell-render'
  },
  {
    dataField: 'capacityPipe',
    caption: 'Объем ГП по ТМ',
    dataType: 'number'
  },
  {
    dataField: 'capacityPipeMeasure',
    caption: 'Объем ГП, ЕИ',
    dataType: 'number',
    notVisible: true
  },
  {
    dataField: 'capacityTied',
    caption: 'Объем привязанного',
    dataType: 'number'
  },
  {
    dataField: 'capacityAccepted',
    caption: 'Подтверждено (передано в SAP)',
    dataType: 'number'
  },
  {
    dataField: 'capacityEndProduct',
    caption: 'Введенный объем ГП',
    dataType: 'number'
  },
  {
    dataField: 'capacityAvailable',
    caption: 'Доступно к производству',
    dataType: 'number'
  },
  {
    dataField: 'project',
    caption: 'Проект',
    dataType: 'string'
  },
  {
    dataField: 'clientName',
    caption: 'Наименование конечного клиента',
    dataType: 'string'
  },
  {
    dataField: 'contractDate',
    caption: 'Дата контракта',
    dataType: 'date',
    cellRender: cellRenderParseData
  },
  {
    dataField: 'contractId',
    caption: 'Номер контракта',
    dataType: 'string'
  },
  {
    dataField: 'customerName',
    caption: 'Наименование заказчика',
    dataType: 'string'
  },
  {
    dataField: 'executorName',
    caption: 'Наименование исполнителя',
    dataType: 'string'
  },
  {
    dataField: 'expireDate',
    caption: 'Дата окончания заказа на переработку',
    dataType: 'date',
    cellRender: cellRenderParseData
  },
  {
    dataField: 'lengthCoil',
    caption: 'Размер ПФ, длина',
    dataType: 'number'
  },
  {
    dataField: 'lengthPipe',
    caption: 'Длина ГП',
    dataType: 'number'
  },
  {
    dataField: 'lineStatus',
    caption: 'Код статуса позиции заказа',
    cellRender: cellRenderClosedStatus,
    notVisible: true,
    dataType: 'string'
  },
  {
    dataField: 'lineStatusTitle',
    caption: 'Статус позиции заказа',
    cellRender: cellRenderStatusAct,
    dataType: 'string'
  },
  {
    dataField: 'markCoil',
    caption: 'Марка стали ПФ',
    dataType: 'string'
  },
  {
    dataField: 'markPipe',
    caption: 'Марка стали ГП',
    dataType: 'string'
  },
  {
    dataField: 'orderDate',
    caption: 'Дата заказа на переработку',
    dataType: 'date',
    cellRender: cellRenderParseData
  },
  {
    dataField: 'orderStatus',
    caption: 'Код статуса заказа на переработку',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'orderStatusTitle',
    caption: 'Статус заказа на переработку',
    cellRender: cellRenderStatusAct,
    dataType: 'string'
  },
  {
    dataField: 'price',
    caption: 'Цена услуги по переработке, р/тн с НДС',
    dataType: 'number'
  },
  {
    dataField: 'sizeCoilMeasure',
    caption: 'Размер ПФ, ЕИ',
    notVisible: true,
    dataType: 'string'
  },
  {
    dataField: 'sizePipe',
    caption: 'Размер ГП',
    dataType: 'string'
  },
  {
    dataField: 'sizePipeMeasure',
    caption: 'Длина ГП, ЕИ',
    notVisible: true,
    dataType: 'string'
  },
  {
    dataField: 'skuCoil',
    caption: 'SKU ПФ',
    dataType: 'string'
  },
  {
    dataField: 'skuCoilId',
    caption: 'id SKU ПФ',
    dataType: 'string'
  },
  {
    dataField: 'skuPipe',
    caption: 'SKU ГП',
    dataType: 'string'
  },
  {
    dataField: 'skuPipeId',
    caption: 'id SKU ГП',
    dataType: 'string'
  },
  {
    dataField: 'standardCoil',
    caption: 'Стандарт на ПФ',
    dataType: 'string'
  },
  {
    dataField: 'standardPipe',
    caption: 'Стандарт на ГП',
    dataType: 'string'
  },
  {
    dataField: 'weightCoil',
    caption: 'Вес ПФ',
    dataType: 'number'
  },
  {
    dataField: 'weightCoilMeasure',
    caption: 'Вес ПФ, ЕИ',
    notVisible: true,
    dataType: 'string'
  },
  {
    dataField: 'widthCoil',
    caption: 'Размер ПФ, ширина',
    dataType: 'number'
  },
  {
    dataField: 'zdvlOrderNumId',
    caption: 'id заказа на переработку',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'plantDescr',
    caption: 'Склад',
    dataType: 'string'
  }
];

export default zdvlColumnDataGrid;
